import { Box, Grid, Tooltip } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LeadSurveyForm from "./LeadSurveyForm";
import CustomButton from "../../../../components/common/button/CustomButton";
import useStyles from "./leadSurveyStyle";
import AlertPopup from "../../../../components/common/alertPopup/AlertPopup";
import { setSurveyTooltipsAction, updateSurveyTooltipAction } from "../../../../store/reducers/leadSurveySlice";
import { getSingleLeadAction } from "../../../../store/reducers/leadSlice";

const LeadSurvey: FC<any> = ({}) => {
  const [show, setShow] = useState(false);
  const [type, setType] = useState("");
  const [showVolumeAlert, setShowVolumeAlert] = useState(false);
  const classes = useStyles({ show });
  const dispatch = useDispatch();
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { isSurveyTooltips } = useSelector((state: any) => state.leadSurvey);

  const hasMissingVolume = !!leadDetails?.lead?.is_customer_items;

  const openSurvey = () => {
    setShow(true);
    setType("survey");
  };

  const handleSurveyButtonClick = () => {
    if (hasMissingVolume) {
      setShowVolumeAlert(true);
    } else {
      openSurvey();
    }
  };

  const handleDisabledAlert = () => {
    dispatch(updateSurveyTooltipAction(leadDetails?.lead?.survey_id));
    setShowVolumeAlert(false);
    openSurvey();
  };

  useEffect(()=>{
    if(isSurveyTooltips){
      dispatch(setSurveyTooltipsAction(false));
      dispatch(getSingleLeadAction(leadDetails?.lead?.generated_id));
    }
  },[isSurveyTooltips])

  return (
    <>
      <Grid item xs={12} md={2.4}>
        <Box sx={{ position: "relative", display: "inline-block", width: "100%" }}>
          <CustomButton
            style={{ padding: "10px 30px", height: "36px", width: "100%" }}
            title="Survey"
            onClick={handleSurveyButtonClick}
          />
          {hasMissingVolume && (
            <Tooltip title="Some items do not have volume" arrow>
              <Box
                sx={{
                  position: "absolute",
                  top: -5,
                  right: -5,
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  backgroundColor: "#d32f2f",
                  border: "2px solid #fff",
                  cursor: "pointer",
                  zIndex: 1,
                }}
                onClick={handleSurveyButtonClick}
              />
            </Tooltip>
          )}
        </Box>
      </Grid>

      {showVolumeAlert && (
        <AlertPopup
          open={showVolumeAlert}
          title="Warning"
          content="Some of the items do not have volume. Do you want to continue?"
          onHide={handleDisabledAlert}
          submitHandler={handleDisabledAlert}
          yesText="OK"
          // noText="Cancel"
        />
      )}

      {show && type === "survey" && (
        <section className={show ? classes.surveyPopupOverlay : ""}>
          <LeadSurveyForm show={show} setShow={setShow} />
        </section>
      )}
    </>
  );
};

export default LeadSurvey;
